import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";

export const storeGroup = dictionary.extend({
  description: z.string().max(250).optional(),
});

export const readStoreGroup = storeGroup.readonly();

export const writeStoreGroup = storeGroup
  .extend({
    stores: z.object({
      add: z.array(z.string().length(26)),
      delete: z.array(z.string().length(26)),
    }),
  })
  .omit({ id: true });

export const displayStoreGroup = storeGroup
  .omit({
    id: true,
  })
  .readonly();
